const sidebarNav = [
	{
		link: '/dashboard',
		section: 'dashboard',
		icon: 'bx bx-home-alt',
		text: 'DASHBOARD',
	},
	{
		link: '/user-list',
		section: 'user-list',
		icon: 'bx bx-user',
		text: 'USERS LIST',
	},
	{
		link: '/family-list',
		section: 'family-list',
		icon: 'bx bx-receipt',
		text: 'FAMILY LIST',
	},
	{
		link: '/devices-list',
		section: 'devices-list',
		icon: 'bx bx-cube',
		text: 'DEVICES LIST ',
	},
	{
		link: '/tutorials',
		section: 'tutorials',
		icon: 'bx bx-book-content',
		text: 'TUTORIAL LIST',
	},
	{
		link: '/point-list',
		section: 'point-list',
		icon: 'bx bx-wallet-alt',
		text: 'POINT LIST',
	},
	{
		link: '/send-email',
		section: 'send-email',
		icon: 'bx bx-envelope',
		text: 'SEND EMAIL',
	},
	{
		link: '/group-sale',
		section: 'group-sale',
		icon: 'bx bx-group',
		text: 'GROUP SALE',
	},
	{
		link: '/error-log',
		section: 'error-log',
		icon: 'bx bx-error',
		text: 'ERROR LOG',
	},

	// {
	// 	link: '/settings',
	// 	section: 'settings',
	// 	icon: <i className="bx bx-cog"></i>,
	// 	text: 'Settings',
	// },
];

export default sidebarNav;
